import { FieldValues, Path, UseFormRegister, FieldError } from "react-hook-form/dist/types";

interface HookFormTextProps<T extends FieldValues> {
  name: Path<T>;
  label: string;
  register: UseFormRegister<T>;
  errorMessage: string | FieldError | undefined;
  disabled?: boolean;
  placeholder?: string;
  example?: string;
  required?: boolean;
}

export default function HookFormTextInput<T extends FieldValues>(
  props: HookFormTextProps<T>,
) {
  return (
    <div className="form-control mb-4">
      <label
        className="label"
        htmlFor={props.name}
      >
        <span className="label-text font-medium text-base-content">
          {props.label}
          {props.required && <span className="text-error ml-1">*</span>}
        </span>
      </label>
      <input
        id={props.name}
        className="input input-bordered mb-1"
        {...props.register(props.name)}
        disabled={props.disabled}
        placeholder={props.placeholder}
      />
      {props.example && (
        <p className="mb-2 text-xs text-base-content/60">
          {props.example}
        </p>
      )}
      {props.errorMessage && (
        <p className="text-xs italic text-error">
          {typeof props.errorMessage === 'string' ? props.errorMessage : props.errorMessage.message}
        </p>
      )}
    </div>
  );
}
